import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function WarningFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M14.6594 3.75843C13.4752 1.6764 10.4762 1.67068 9.29751 3.7599L9.29641 3.76186L1.64982 17.1616C0.47343 19.2197 1.95929 21.7809 4.32987 21.7809H19.6489C22.0128 21.7809 23.5071 19.2132 22.3298 17.1614L22.3293 17.1605L14.6599 3.75935L14.6594 3.75843ZM12.7502 9.38C12.7502 8.96579 12.4144 8.63 12.0002 8.63C11.586 8.63 11.2502 8.96579 11.2502 9.38V13.12C11.2502 13.5342 11.586 13.87 12.0002 13.87C12.4144 13.87 12.7502 13.5342 12.7502 13.12V9.38ZM11.9902 15.375L11.9852 15.375L11.9802 15.375C11.9594 15.375 11.9387 15.3759 11.9183 15.3775C11.398 15.4141 10.9902 15.845 10.9902 16.375C10.9902 16.8997 11.4168 17.375 11.9902 17.375C12.2854 17.375 12.5311 17.2423 12.6943 17.0791C12.8575 16.9159 12.9902 16.6701 12.9902 16.375C12.9902 15.8152 12.5478 15.4198 12.0637 15.3786C12.0396 15.3762 12.015 15.375 11.9902 15.375Z" fill="currentColor" /></Svg>;
}
export default WarningFill;